module.exports = __webpack_public_path__ + "img/DTYLX_tha.8c9fef24.png";